module.exports = __webpack_public_path__ + "img/my_coaching.2b7ddc6a.svg";